export default __webpack_public_path__ + "img/16.3b8ad45a.jpg";